import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import {
  loyaltyContainer,
  checkoutContainer,
  subscriptionContainer,
} from 'src/models'
import { Button, Modal } from 'react-bootstrap'
import { CommonForm } from 'src/views/components'
import { BsFillExclamationCircleFill } from 'react-icons/bs'
import { schema } from 'src/views/components/StoreCredits/validationSchema'
import { formInput } from 'src/views/components/StoreCredits/formInput'
import { APPConfig } from 'config/appConfig'
import { convertToBoolean } from 'src/utils'

import './styles.scss'

@observer
class ProcessNowModal extends React.Component {
  @observable isToShowInputField = true
  @observable isStoreCreditsApplied = false
  @observable appliedStoreCreditPoints = ''
  isToEnableOneTimeFrequency =
    APPConfig?.getAppConfig()?.oneTimeFrequencyEnabled === 'true'
  constructor(props) {
    super(props)
    // this.state = {
    //   isCallInProgress: false,
    // }
  }
  componentDidMount() {
    const currentPoints = loyaltyContainer.getStoreCredits() || 0
    const orders = subscriptionContainer.subscriptionPreferenceResponse?.order
    const orderTotal = parseFloat(orders?.monthlyTotal || 0.0).toFixed(2)
    this.appliedStoreCreditPoints =
      orderTotal > currentPoints ? currentPoints : orderTotal
  }
  // handleApply = async (data, resetForm) => {
  //   const payments = get(cartContainer, 'cartResponse.payments', [])
  //   if (payments.length) {
  //     await checkoutContainer.deleteAllCreditCardPayments()
  //   }
  //   const response = await checkoutContainer.addStoreCreditPayment(
  //     data.storeCredit
  //   )
  //   if (checkoutContainer.isSuccessResponse(response)) {
  //     checkoutContainer.isPaymentCallsInProgress = false
  //     await cartContainer.viewCart()
  //     resetForm && resetForm()
  //     toastState.setToastMessage(
  //       i18nTranslate('storeCredit.success', 'Store credit added to cart successfully')
  //     )
  //     const totalAmountUnpaid =
  //       get(cartContainer, 'cartResponse.paymentValue.totalAmountUnpaid') || 0.0
  //     if (this.props.isCheckOutPage && totalAmountUnpaid == 0) {
  //       checkoutContainer.shouldEnablePlaceOrder = true
  //       // cartContainer.checkoutActiveTabIndex = 8
  //       checkoutContainer.isCreditCardEnable = false
  //     }
  //     if (this.props.isCheckOutPage) {
  //       analyticsContainer.trackCardPaymentOption('STORE CREDITS')
  //     }
  //   } else {
  //     const errorCode = (response && response.code) || ''
  //     let toastMessage = ''
  //     if (errorCode == 'EOCA0000005' && response.message) {
  //       toastMessage = response.message
  //     } else {
  //       toastMessage = i18nTranslate(
  //         'storeCredit.failure',
  //         'Unable to add store credit to cart, please try again'
  //       )
  //     }
  //     toastState.setToastMessage(toastMessage)
  //   }
  // }

  handleValueChange = event => {
    this.appliedStoreCreditPoints = event.target.value
    this.isStoreCreditsApplied = false
  }

  handleApply = (appliedValue, resetForm) => {
    this.isStoreCreditsApplied = true
    this.appliedStoreCreditPoints = appliedValue.storeCredit
    resetForm && resetForm()
  }

  renderSubmitButton = () => {
    const successIconTitle = i18nTranslate(
      'icons.toolTipSuccess',
      'Success Icon',
      {
        nameSpace: 'ssr-resource',
      }
    )
    return !this.isStoreCreditsApplied ? (
      <Button
        data-testid="qa-store-credit-apply"
        className={'checkout-apply-button ml-2 text-capitalize'}
        variant="primary"
        type="submit"
        disabled={false}>
        {i18nTranslate('storecredits.submit', 'Apply')}
      </Button>
    ) : (
      <div className="mt-1">
        <span className="ml-2 success-tick">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9">
            <title>{successIconTitle}</title>
            <path
              fill="#8C6E43"
              d="M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z"
            />
          </svg>
        </span>
        <span className="applied-text">
          {i18nTranslate('processNow.appliedText', 'Applied')}
        </span>
      </div>
    )
  }

  renderInputField = (currentPoints, orderTotal) => {
    const hasDonation = convertToBoolean(
      subscriptionContainer.subscriptionPreferenceResponse
        ?.hasDonationRoundUp || 'false'
    )
    const totalAmountUnpaid = hasDonation ? orderTotal - 1 : orderTotal
    // const formInputJson = formInput(false)
    return (
      <CommonForm
        schema={schema({ currentPoints, totalAmountUnpaid })}
        formTypeJson={formInput({
          isCheckOutPage: false,
          handleValueChange: this.handleValueChange,
          appliedStoreCreditPoints: this.appliedStoreCreditPoints,
        })}
        SubmitButtonProps={this.renderSubmitButton}
        onSubmit={async (formValues, resetForm) => {
          await this.handleApply(formValues, resetForm)
        }}
        hasInlineSubmitButton={true}
        classNameValue={{
          formClassName: 'd-flex mt-3',
          formLabelClassName: 'text-uppercase email-label',
        }}
      />
    )
  }

  // renderInputField = (currentPoints, orderTotal) => {
  //   const displayValue = currentPoints > orderTotal ? orderTotal : currentPoints
  //   const successIconTitle = i18nTranslate('icons.toolTipSuccess', 'Success Icon')
  //   return (
  //     <div className="input-button-wrapper">
  //       <input
  //         type="text"
  //         placeholder={`$${displayValue}`}
  //         disabled
  //         className="modal-input"
  //       />
  //       {!this.isStoreCreditsApplied ? (
  //         <Button
  //           onClick={() => {
  //             this.isStoreCreditsApplied = true
  //           }}
  //           className="ml-2 modal-apply-button">
  //           <Trans i18nKey="processNow.applyButton">Apply</Trans>
  //         </Button>
  //       ) : (
  //         <>
  //           <span className="ml-2 success-tick">
  //             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9">
  //               <title>{successIconTitle}</title>
  //               <path
  //                 fill="#8C6E43"
  //                 d="M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z"
  //               />
  //             </svg>
  //           </span>
  //           <span className="applied-text">
  //             <Trans i18nKey="processNow.appliedText">Applied</Trans>
  //           </span>
  //         </>
  //       )}
  //     </div>
  //   )
  // }
  renderStoreCredit = (currentPoints, orderTotal) => {
    const displayPoints = parseFloat(currentPoints).toFixed(2)
    return (
      <div className="subscription-box-store-credit">
        <h2 className="subscription-box-store-credit-heading">
          {i18nTranslate(
            'processNow.storeCreditHeading',
            'Store Credit Available!'
          )}
        </h2>
        <p>
          {i18nTranslate('processNow.youHave', 'You have')}
          <span>{` $${displayPoints} `}</span>
          {i18nTranslate(
            'processNow.applyConfirmation',
            'in store credit available. Would you like to apply store credit to this order?'
          )}
        </p>
        <Button
          onClick={() =>
            this.isToShowInputField(
              (this.appliedStoreCreditPoints =
                orderTotal > currentPoints ? currentPoints : orderTotal)
            )
          }
          className={
            this.isToShowInputField
              ? 'modal-yes-button-active'
              : 'modal-yes-button'
          }>
          {i18nTranslate('processNow.yesButton', 'Yes')}
        </Button>
        <Button
          onClick={() => {
            this.isToShowInputField = false
            this.isStoreCreditsApplied = false
          }}
          className={
            this.isToShowInputField
              ? 'modal-no-button ml-2'
              : 'modal-no-button-active ml-2'
          }>
          {i18nTranslate('processNow.noButton', 'No')}
        </Button>
        {this.isToShowInputField &&
          this.renderInputField(currentPoints, orderTotal)}
      </div>
    )
  }
  renderLegacyCardDetails = () => {
    let { transaction, transactionGrouping } =
      subscriptionContainer.subscriptionPreferenceResponse

    if (transaction) {
      const paymentsElements = Object.keys(transaction).map(transactionKey => {
        const total = transaction[transactionKey]?.value?.grandTotal || 0
        const subscriptionIdToGetCardDetails =
          (transactionGrouping && transactionGrouping[transactionKey]?.[0]) ||
          ''
        const subscriptionDataToGetCardDetails =
          subscriptionContainer.selectedSubscription?.find(
            subscription => subscription.id === subscriptionIdToGetCardDetails
          )
        const cardNumber =
          subscriptionDataToGetCardDetails?.paymentInfo?.cardNumber || ''
        return (
          <div className="mb-0" key={transactionKey}>
            {i18nTranslate(
              'processNow.migratedSubscriptionDisclaimer',
              'Total charged to card ending in '
            )}
            {cardNumber} : <b>${total}</b>
          </div>
        )
      })
      return paymentsElements
    } else {
      return <></>
    }
  }
  renderProcessingNowModal = (currentPoints, orderTotal, payment) => {
    // let orderTotalDisplayValue = this.isStoreCreditsApplied
    //   ? currentPoints > orderTotal
    //     ? 0
    //     : orderTotal - currentPoints
    //   : orderTotal
    let orderTotalDisplayValue = this.isStoreCreditsApplied
      ? orderTotal - this.appliedStoreCreditPoints
      : orderTotal
    let showDonation = convertToBoolean(
      subscriptionContainer.subscriptionPreferenceResponse
        ?.hasDonationRoundUp || 'false'
    )

    orderTotalDisplayValue =
      this.isToEnableOneTimeFrequency && this.props.areAllOtp?.toShowOTPError
        ? '0.00'
        : parseFloat(orderTotalDisplayValue).toFixed(2)
    //const { csrAdminCookie } = getAppConfig()
    //const isCSRAdmin = getCookie(csrAdminCookie) ? true : false
    return (
      <Modal centered show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header
          closeButton
          className="process-now-modal-header border-0"
        />
        <Modal.Body
          className={`process-now-modal-body ${this.props.legacyCheck ? 'has-legacy' : 'only-primary'
            }`}>
          <h1 className="process-now-modal-heading">
            {i18nTranslate('processNow.heading', 'Process Now')}
          </h1>
          <div className="mb-3 process-now-modal-max-height">
            <p>
              {/* {i18nTranslate(
              'processNow.info',
              'Clicking "Process Now" below will immediately charge and ship this order. Note that this will have no effect on future scheduled subscription orders.'
            )} */}
              {i18nTranslate(
                'processNow.submitText',
                "Clicking SUBMIT ORDER will process this month's subscription items. Submitting your order now will not change your regularly scheduled processing date for future orders."
              )}
            </p>
            {currentPoints > 0 &&
              checkoutContainer.enableGlobalAccountCredits &&
              this.renderStoreCredit(currentPoints, orderTotal)}
            {this.props.legacyCheck && (
              <div className="subscription-primary-subscription-title">
                {i18nTranslate('processNow.primary', 'PRIMARY SUBSCRIPTION')}
              </div>
            )}
            <div className={'order-total'}>
              <span className="order-total-label pr-1">
                {i18nTranslate('processNow.orderTotal', 'Order Total:')}
              </span>
              {
                // YLDCP-4857 - donation text added as per BA'S recommendation
                showDonation ? (
                  <span className="donation-text">
                    <span className="order-total-value">
                      ${(orderTotalDisplayValue - 1).toFixed(2)}
                    </span>
                    <span> + </span>
                    <span className="donation-text-bold">
                      $1
                      {i18nTranslate('processNow.DonationText', ' Donation ')}
                    </span>
                    {i18nTranslate(
                      'processNow.DonationTextDescription',
                      'Store credit cannot be used for donation'
                    )}
                  </span>
                ) : (
                  <span className="order-total-value">
                    ${orderTotalDisplayValue}
                  </span>
                )
              }
            </div>
            <p className="order-total-text">
              {i18nTranslate(
                'processNow.disclaimer',
                'Amount to be charged to credit card ending in '
              )}
              {payment?.cardNumber || ''}
            </p>
            {this.props.areAllOtp?.toShowOTPError &&
              this.isToEnableOneTimeFrequency && (
                <div className="otp-error">
                  <span className="otp-error-icon">
                    <BsFillExclamationCircleFill
                      size="1.5rem"
                      className={`tick-icon red`}
                    />
                  </span>
                  <span className="otp-error-info">
                    {i18nTranslate(
                      'processNow.otpError',
                      'Order cannot be processed. You must be subscribed to items to process one-time items.'
                    )}
                  </span>
                </div>
              )}
            {this.props.legacyCheck && (
              <div className="migrated-subscriptions-container">
                <div className="subscription-migrated-subscription-title">
                  {i18nTranslate(
                    'subscription.migratedSubscriptionsWithBracket',
                    'Migrated Subscription(s)'
                  ).toUpperCase()}
                </div>
                {this.renderLegacyCardDetails()}
              </div>
            )}
          </div>
          <Button
            data-testid="modal-process-btn"
            className="modal-process-now-button"
            disabled={
              this.props.disable ||
              (this.props.areAllOtp?.toDisableSubmitOrder &&
                this.isToEnableOneTimeFrequency)
            }
            onClick={async () => {
              await this.props.processNow(
                this.isStoreCreditsApplied,
                this.appliedStoreCreditPoints
              )
            }}>
            {/* {i18nTranslate('processNow.processNowButton', 'Process Now')} */}
            {i18nTranslate('processNow.submitOrderButton', 'Submit Order')}
          </Button>
          <Button className="modal-cancel-button" onClick={this.props.onHide}>
            {i18nTranslate('processNow.cancelButton', 'Cancel')}
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
  render() {
    const currentPoints = loyaltyContainer.getStoreCredits() || 0
    const orders =
      subscriptionContainer.subscriptionPreferenceResponse?.order || {}
    const payment =
      subscriptionContainer.subscriptionPreferenceResponse?.payment || {}
    const orderTotal = parseFloat(orders?.monthlyTotal || 0.0).toFixed(2)
    return (
      <>{this.renderProcessingNowModal(currentPoints, orderTotal, payment)}</>
    )
  }
}

export default ProcessNowModal
export { ProcessNowModal }
